// extracted by mini-css-extract-plugin
export default {"children-number":"ColumnCell_children-number__Wv1rN"};